import ApplicationController from '../application_controller';
import GestorSeleccionListado from '../utils/GestorSeleccionListado';
import { EVENTO_ANTES_CARGAR } from '../modal_remoto_controller';

/*
  Gestiona el listado de la gestión de servicios
*/
export default class extends ApplicationController {
  connect() {
    this.gestorSeleccionListado = new GestorSeleccionListado(this.element);
    this.gestorSeleccionListado.connect();
    this.#conectarBotones();
  }

  #conectarBotones() {
    this.element.querySelectorAll('.btn-cambiar-estado').forEach((boton) => {
      boton.addEventListener(EVENTO_ANTES_CARGAR, (event) => {
        const filtros = this.gestorSeleccionListado.getParametrosFiltros();
        Object.keys(filtros).forEach((key) => {
          event.detail.url.searchParams.append(key, filtros[key]);
        });
      });
    });
  }
}
